import { useGlobalContainerRef } from '@/wc/helper/ref';
import { IconHelp, Tooltip } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from './styles.module.scss';

type Props = {
  label: string;
  tooltip: string;
};

const cx = classnames.bind(styles);

export const MenuItem: FC<Props> = memo(({ label, tooltip }) => {
  const container = useGlobalContainerRef();
  return (
    <div className={cx(styles.itemContainer)}>
      <span>{label}</span>
      <Tooltip title={tooltip} placement='top' getPopupContainer={container}>
        <div className={cx(styles.iconContainer)}>
          <IconHelp size={14} />
        </div>
      </Tooltip>
    </div>
  );
});

MenuItem.displayName = 'MenuItem';
